import { createRoot, createSignal } from 'solid-js';

/**
 * The `myContent` cookie isn't reactive, so `addMyContent` and
 * `deleteMyContentItemByPermalink` call `notifyChanged()`, and readers track
 * `revision`. Lets the bookmarks list drop a card the moment its heart is
 * unliked, whichever card component owns that heart.
 */
function createMyContentStore() {
    const [revision, setRevision] = createSignal(0);

    return {
        revision,
        notifyChanged: () => setRevision((r) => r + 1),
    };
}

export default createRoot(createMyContentStore);
